module.exports = __webpack_public_path__ + "img/pro.b3cffb01.jpg";